import {
  AbstractDropdownItem,
  AbstractDropdownItemButtonProps,
  AbstractDropdownItemLinkProps,
} from '../abstract-dropdown/AbstractDropdownItem';

export type MenuItemButtonProps = Omit<AbstractDropdownItemButtonProps, OmittedProps>;
export type MenuItemLinkProps = Omit<AbstractDropdownItemLinkProps, OmittedProps>;

type OmittedProps = 'consumerName' | 'providerName' | 'role';

export function MenuItem(props: MenuItemButtonProps): JSX.Element;
export function MenuItem(props: MenuItemLinkProps): JSX.Element;
export function MenuItem(props: MenuItemButtonProps | MenuItemLinkProps): JSX.Element;

export function MenuItem(forwardedProps: MenuItemButtonProps | MenuItemLinkProps) {
  return <AbstractDropdownItem {...forwardedProps} consumerName="MenuItem" providerName="Menu" role="menuitem" />;
}
